import React, { ElementType, FC } from 'react';
import cls from 'classnames';
import {  TextProps } from './Text.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';

export const classNames = getClassNames('sds-text');

const mapAlignmentToClass = {
	'left': 'text-left',
	'center': 'text-center',
	'right': 'text-right',
}

const Text = (props: TextProps) => {
	const { className, children, 
		textStyle,
		color, 
		textAlign = 'left',
		overflow = false,
		maxLines,
		tag,
		...rest
 } = props

	const Tag = (tag || 'p') as ElementType;

	const textAlignClass = mapAlignmentToClass[textAlign]
	const overflowClass = overflow ? 'truncate' : ''
	const maxLineClass = maxLines ? 'lineClamp' : ''
	const maxLineStyle = maxLines ? {'--numMaxLines': maxLines} : {}
	const defaultClasses = "whitespace-pre-wrap" //Preserves newlines and spaces

	return <Tag 
		{...rest}
		className={cls(getRootClassListFromProps(classNames, props), className, defaultClasses, color, textStyle, textAlignClass, overflowClass, maxLineClass)}
		style={maxLineStyle}
		>
		{children}
	</Tag>;
};

Text.displayName = 'Text';
export default Text;
